<template>
	<div>
		<v-tooltip right>
			<div slot="activator" class="indicator-container">
				<div class="item red"></div>
				<div class="item amber"></div>
				<div class="item green"></div>
			</div>

			<span>This discussion point will be ranked using our Traffic Light Rating system</span>
		</v-tooltip>
	</div>
</template>

<script>
	export default {};
</script>

<style scoped>
	.indicator-container {
		width: 30px;
		display: inline;
	}
	.item {
		background-color: red;
		border-radius: 50%;
		height: 8px !important;
		width: 8px !important;
		display: inline-block;
		margin-right: 2px;
	}
</style>
